import React, { useEffect, useState } from "react";
import ElementContainer from "../../../shared/ElementContainer";
import Modal from "../../../shared/Modal";
import LoadingSpinner from "../../../shared/LoadingSpinner";
import { getSharedConsumer } from "../../../../channels/consumer";

import { FaTimes } from "react-icons/fa";
import { FaSpinner } from "react-icons/fa";

const UnityGameElement = (props) => {
  const {
    title,
    title_color,
    id,
    requirable,
    status,
    token,
    completed,
    url,
    configuration,
    splash_image,
    active_track,
    user,
  } = props;

  const p3gGames = [
    "Play Acceleration City!",
    "Play Super Slime Battle!",
    "Play Zillah City: Fall of the Toxibots",
    "Play Zillah Beats",
    "Play Ghosts of the USS Salazar",
  ];
  const cableRequired = requirable && user && token && !p3gGames.includes(title);

  const [initialize, setInitialize] = useState(false);
  const [display, setDisplay] = useState(false);
  const [hideSpinner, setHideSpinner] = useState(false);
  const [cableStatus, setCableStatus] = useState(
    cableRequired ? "connecting" : "ready"
  );

  useEffect(() => {
    if (!cableRequired) {
      return undefined;
    }

    let mounted = true;
    const subscription = getSharedConsumer(token).subscriptions.create(
      { channel: "UserRequirementChannel", id: user.id },
      {
        connected() {
          if (mounted) {
            setCableStatus("ready");
          }
        },
        disconnected() {
          if (mounted) {
            setCableStatus("reconnecting");
          }
        },
        rejected() {
          if (mounted) {
            setCableStatus("reconnecting");
          }
        },
      }
    );

    return () => {
      mounted = false;
      subscription.unsubscribe();
    };
  }, [cableRequired, token, user]);

  const closeDisplay = () => setDisplay(false);

  const localDevelopment = ["localhost", "127.0.0.1"].includes(
    window.location.hostname
  );

  const openActivity = () => {
    setInitialize(true);
    setDisplay(true);
    setHideSpinner(false);
  };

  const cursor = {
    cursor: "pointer",
  };

  const closeButton = {
    borderBottomLeftRadius: 25,
    position: "fixed",
    top: 0,
    right: 0,
  };

  const connectionMessage = () => {
    if (cableStatus === "connecting") {
      return "Connecting to the CS2N progress server...";
    }

    if (localDevelopment) {
      return "The local CS2N Action Cable server is not connected right now. CS2N will keep retrying in the background. Make sure the cable process on port 5001 is running.";
    }

    return "The CS2N progress connection was interrupted. CS2N will keep retrying automatically. You can continue working, but wait for the connection to return before finishing the activity so your completion can be recorded.";
  };

  const connectionNotice =
    cableRequired && cableStatus !== "ready" ? (
      <div className="callout warning m-top-1 m-bottom-0">
        <strong>Progress connection {cableStatus === "connecting" ? "starting" : "reconnecting"}</strong>
        <p className="m-bottom-0">{connectionMessage()}</p>
      </div>
    ) : null;

  return (
    <ElementContainer
      id={id}
      color={title_color}
      title={title}
      icon={"bx-laptop"}
      requirable={requirable}
      status={status}
      completed={completed}
      user={user}
      token={token}
    >
      <div
        onClick={openActivity}
        style={cursor}
        className="btn btn-secondary expand radius drop-shadow"
        role="button"
      >
        <img src={splash_image} />
      </div>

      {connectionNotice}

      {initialize ? (
        <Modal display={display} modalId={id} closeDisplay={closeDisplay}>
          <div className="btn btn-cs2n-red" style={closeButton}>
            <FaTimes className="icon-medium" /> Close Activity
          </div>
          {cableRequired && cableStatus !== "ready" ? connectionNotice : null}
          {hideSpinner ? null : <LoadingSpinner />}
          <iframe
            id="unity_game_element"
            src={`${url}?id=${id}&track_id=${active_track}&token=${token}&baseUrl=${window.location.origin}&configuration=${configuration}`}
            onLoad={() => setHideSpinner(true)}
          />
        </Modal>
      ) : null}
    </ElementContainer>
  );
};
const Spinner = () => {
  const spinnerStyle = {
    backgroundColor: "white",
    position: "absolute",
    textAlign: "center",
    top: "45%",
    left: 0,
    width: "100%",
    padding: 10,
    color: "gray",
  };

  const spinnerIcon = {
    fontSize: 72,
  };

  return (
    <div style={spinnerStyle}>
      <FaSpinner style={spinnerIcon} className="bx-loader-circle bx-spin" />
      <p className="m-bottom-0">Loading. Please wait..</p>
    </div>
  );
};
export default UnityGameElement;
